import type { MessageDescriptor } from 'react-intl';

export interface FieldValidation {
  minLength?: number;
  maxLength?: number;
  patterns?: { pattern: string; message: MessageDescriptor }[];
}

export interface FieldConfig {
  span?: number;
  validation?: FieldValidation;
}

export const BENEFICIARY_FIELD_CONFIG: Record<string, FieldConfig> = {
  nickname: {
    validation: { maxLength: 100 },
  },
  city: { span: 6 },
  state: { span: 6 },
  postcode: {
    span: 6,
    validation: { maxLength: 10 },
  },
  account_number: {
    span: 6,
    validation: {
      minLength: 8,
      maxLength: 34,
    },
  },
  account_routing_number: {
    span: 6,
    validation: {
      patterns: [
        {
          pattern: '^[0-9]+$',
          message: { id: 'beneficiary.validation.onlyDigits', defaultMessage: 'Only digits allowed' },
        },
        {
          pattern: '^[0-9]{9}$',
          message: { id: 'beneficiary.validation.mustBe9Digits', defaultMessage: 'Must be exactly 9 digits' },
        },
      ],
    },
  },
  account_currency: { span: 6 },
};
